        <div *ngIf="dataSource && dataSource.data.length > 0"
         class="table-responsive m-t-30">
            <table mat-table
                [dataSource]="dataSource"
                class="w-100"
                matSort
                matSortDirection="desc"
                matSortActive="financedAmount">
                <ng-container matColumnDef="folio">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Folio
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.folio }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="debtorName">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Deudor
                    </th>
                    <td mat-cell *matCellDef="let element" >
                        <span>{{ element.debtorName }}</span> <br >
                        <span>{{ element.debtorRut }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="invoiceTotalAmount">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Monto Factura
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.invoiceTotalAmount | number }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="financedAmount">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Financiado
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.financedAmount | number }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="rate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Tasa
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.rate | number }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="allInRate">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Tasa Total
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.allInRate | number }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="operationState">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Estado
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.operationState }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="plazo">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Plazo
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>{{ element.plazo | number}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="comment">
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
                        Comentario
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span matTooltip="{{element.comment}}">{{ element.comment }}</span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedCols"></tr>
                <tr mat-row class="cursor-row" [cdkContextMenuTriggerFor]="menu" *matRowDef="let row; columns: displayedCols">
                    <ng-template #menu>
                        <div cdkMenu class="context_menu mat-elevation-z8">
                            <button 
                                cdkMenuItem 
                                class="menu-item" 
                                (click)="selectOperationToUpdate(row)" 
                                mat-raised-button>
                                Recotizar
                            </button>
                            <button 
                                cdkMenuItem
                                color="warn"
                                class="menu-item" mat-raised-button
                                (click)="selectOperationToRemove(row)"
                            >
                              Quitar
                            </button>
                        </div>
                    </ng-template>
                </tr>
            </table>
        </div>
        <span *ngIf="!dataSource || dataSource.data.length == 0">
            <h3 style="font-weight: normal;">Sin operaciones a evaluar</h3>
        </span>

        <h3 style="margin-top: 30px;" *ngIf="dataSourceOrder && dataSourceOrder.data.length > 0">Ordenes Asociadas</h3>

        <div class="table-responsive m-t-30" *ngIf="dataSourceOrder && dataSourceOrder.data.length > 0">
            <table mat-table
            [dataSource]="dataSourceOrder">

                <ng-container matColumnDef="folio">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Folio
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span> {{ element?.folio ? element.folio : "Sin Ordenes" }} </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Code
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>
                            {{                             
                                element?.code
                                ? element.code 
                                : "Sin Ordenes" 
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Monto
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>
                            {{
                            element?.amount
                            ? (element.amount | currency:'CLP':'symbol')
                            : "Sin Ordenes"
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="fechaEmision">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Fecha Emision
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>
                            {{
                            element?.fechaEmision
                            ? (element.fechaEmision | date : "dd-MM-yyyy")
                            : "Sin Ordenes"
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="plazo">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        Plazo
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>
                            {{
                            element?.plazo
                            ? element.plazo
                            : "Sin Ordenes"
                            }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sigfe">
                    <th mat-header-cell *matHeaderCellDef class="th-title">
                        SIGFE
                    </th>
                    <td mat-cell *matCellDef="let element" class="td-text-content">
                        <span>
                            {{
                            element?.sigfe
                            ? element.sigfe
                            : "Sin Ordenes"
                            }}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColsOrder"></tr>
                <tr mat-row class="cursor_table" *matRowDef="let row; columns: displayedColsOrder"></tr>
            </table>
        </div>